var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalorias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.979,
    height: 23.224,
    viewBox: "0 0 14.979 23.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7279",
    "data-name": "Path 7279",
    d: "M-1019.073,870.04c-.4-.59-.807-1.135-1.154-1.716a8.75,8.75,0,0,1-1.28-5.179,8.986,8.986,0,0,1,1.009-3.573,14.521,14.521,0,0,1,3.786-4.72,9.072,9.072,0,0,1,1.041-.69,5.088,5.088,0,0,0-.994,2.558,6.985,6.985,0,0,0,1.311,5.245c.554.748,1.17,1.449,1.755,2.175a12.615,12.615,0,0,1,2.345,4.214,6.741,6.741,0,0,1-2.493,7.641,6.258,6.258,0,0,1-5.526,1.2,8.308,8.308,0,0,1-6.333-5.662,6.466,6.466,0,0,1-.227-2.827,10.989,10.989,0,0,1,1.723-4.776c.035-.057.077-.111.141-.2a5.8,5.8,0,0,0,2.147,5.165A4.268,4.268,0,0,0-1019.073,870.04Z",
    transform: "translate(1025.887 -854.163)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalorias);
export default __webpack_public_path__ + "static/media/Calorias.7ed42c8d194e5bd83daa62c4e27af87f.svg";
export { ForwardRef as ReactComponent };